import { useRef } from "react";
import { motion } from "framer-motion";
import { MoveHorizontal } from "lucide-react";
import { FadeUp, Overline, MaskedLines } from "@/components/Reveal";
import { lenisScroll } from "@/lib/scroll";
import { IMG } from "@/data/site";

export default function Panorama() {
  const containerRef = useRef(null);

  return (
    <section id="panorama" data-testid="panorama-section" className="py-28 md:py-40">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 mb-14">
        <FadeUp>
          <Overline>Panorama &amp; 360°</Overline>
        </FadeUp>
        <div className="mt-8 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <h2 className="font-display font-light text-4xl md:text-5xl lg:text-7xl leading-[0.98] tracking-tight">
            <MaskedLines lines={["EXPERIENCE", "THE SPACE."]} />
          </h2>
          <FadeUp delay={0.2} className="max-w-sm">
            <p className="text-sm text-muted font-light leading-relaxed">
              Seamless panoramic post-production designed to preserve perspective,
              atmosphere and architectural detail.
            </p>
            <button
              data-testid="panorama-cta"
              onClick={() => lenisScroll("#contact")}
              className="mt-6 text-[11px] uppercase tracking-[0.3em] text-bronze hover:text-gold transition-colors duration-300"
            >
              Discover Panorama Editing
            </button>
          </FadeUp>
        </div>
      </div>

      <FadeUp delay={0.1}>
        <div
          ref={containerRef}
          data-testid="panorama-drag-area"
          data-cursor="DRAG"
          className="relative overflow-hidden h-[60vh] md:h-[70vh] border-y hairline"
        >
          <motion.div
            drag="x"
            dragConstraints={containerRef}
            dragElastic={0.06}
            className="h-full w-[190%] md:w-[160%] cursor-grab active:cursor-grabbing"
          >
            <img
              src={IMG.panoImage}
              alt="Modern luxury villa with infinity pool panorama — panorama and 360 editing by VCONTRACTZ"
              className="w-full h-full object-cover pointer-events-none"
              draggable={false}
              loading="lazy"
            />
          </motion.div>
          <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-ink to-transparent pointer-events-none" />
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-3 text-[10px] tracking-[0.35em] uppercase text-ivory/70 pointer-events-none">
            <MoveHorizontal size={14} className="text-gold" />
            Drag to explore
          </div>
        </div>
      </FadeUp>
    </section>
  );
}
